/* ==================================================
  c_staff-ai-fit-hide.js — 客注モードでは AI Fit 診断（チャット）を出さない
  - 見た目は c_theme.css の html.staff-mode [data-tabio-aifit] で隠す（class は <head> で同期付与されるため
    ちらつかない）。ここではさらに AI Fit のルート要素を DOM から外し、c_ai-fit-diagnosis.js に初期化させない。
    CSS だけだと ?ai-fit=open の URL でパネルが自動で開き、背景スクロールの固定（body position:fixed）だけが
    残ってページが動かなくなるため。
  - 判定は CSS と同じ html.staff-mode（staff_mode_token cookie）に加え、URL に auth_code がある場合も客注モードとみなす。
    ログイン直後の最初のページは c_staff-mode-header-bar.js が auth_code を非同期でトークンに交換してから
    replaceState で URL を消すため、この時点ではまだ cookie も html.staff-mode も無い（交換失敗時はログインへ戻るか auth_code を外して再読み込みされるので
    ここで外しても影響なし）。header bar はこれより後の defer なので、実行時点で auth_code は必ず URL に残っている。
  - head の defer なので、セクション末尾で defer 読み込みされる c_ai-fit-diagnosis.js より先に実行される
    （defer は文書順。どちらも HTML 解析完了後なので、この時点でルート要素は揃っている）。
  - AI Fit のファイル（sections/c_ai-fit-diagnosis.liquid・assets/c_ai-fit-diagnosis.*）は変更しない。
  ===================================================*/
(function () {
  'use strict';
  try {
    var isStaffMode =
      document.documentElement.classList.contains('staff-mode') ||
      /[?&]auth_code=/.test(window.location.search);
    if (!isStaffMode) return;
    var roots = document.querySelectorAll('[data-tabio-aifit]');
    for (var i = 0; i < roots.length; i++) roots[i].remove();
  } catch (e) {}
})();
